import type { TFunction } from "i18next";

export const translateError = (
  code: string,
  fallback: string,
  t: TFunction<["common"]>,
): string => {
  switch (code) {
    case "NotAuthorizedException":
      return t("common:passwordLogin.errors.invalidCredentials");
    case "UserNotFoundException":
      return t("common:passwordLogin.errors.userNotFound");
    case "PasswordResetRequiredException":
      return t("common:passwordLogin.errors.passwordResetRequired");
    case "UserNotConfirmedException":
      return t("common:passwordLogin.errors.userNotConfirmed");
    case "CodeMismatchException":
      return t("common:passwordLogin.errors.codeMismatch");
    case "ExpiredCodeException":
      return t("common:passwordLogin.errors.codeExpired");
    case "InvalidPasswordException":
      return t("common:passwordLogin.errors.invalidPassword");
    case "TooManyRequestsException":
    case "LimitExceededException":
      return t("common:passwordLogin.errors.tooManyRequests");
    default:
      return fallback;
  }
};
